import React, { useState } from "react";
import AnimatedModal from "../../ReusableComponents/AnimatedModal";
import * as API from "../../api.js";
import { Snackbar, Alert } from "@mui/material";

const AddTowerImageSet = ({ isOpen, onRequestClose, onSubmit, planData }) => {
  const [imageSetName, setImageSetName] = useState("");
  const [location, setLocation] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!imageSetName) {
      setError("Please enter a collection name");
      return;
    }

    const planId = planData?.id;
    const projectId = planData?.project_id;

    setLoading(true);
    setError("");

    try {
      const response = await API.createImageCollection(projectId, planId, imageSetName);
      setSuccess(true);
      setImageSetName(""); 
      onSubmit && onSubmit(response); 
      onRequestClose(); 
    } catch (err) {
      console.error(err);
      setError(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AnimatedModal isOpen={isOpen} onRequestClose={onRequestClose} width="35%" height="auto">
        <div className="create-tower-container">
          <div className="create-tower-header">
            <p className="create-tower-title">Add Image Set</p>
            <button onClick={onRequestClose} className="create-tower-close">✕</button>
          </div>

          <div className="create-tower-form">
            <label className="create-tower-label">Name</label>
            <input
              type="text"
              placeholder="Enter name"
              value={imageSetName}
              onChange={(e) => setImageSetName(e.target.value)}
              className="create-tower-input"
            />
             <label className="create-tower-label">Location</label>
            <input
              type="text"
              placeholder="Enter location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              className="create-tower-input"
            />
          </div>

          <div className="create-tower-footer">
            <button
              onClick={handleSubmit}
              className="create-tower-submit"
              disabled={loading}
            >
              {loading ? "Adding..." : "Add"}
            </button>
          </div>

          {/* Snackbar for error */}
          {/* <Snackbar open={!!error} autoHideDuration={4000} onClose={() => setError("")}>
            <Alert severity="error">{error}</Alert>
          </Snackbar> */}

          {/* Snackbar for success */}
          {/* <Snackbar open={success} autoHideDuration={4000} onClose={() => setSuccess(false)}>
            <Alert severity="success">Image collection added successfully!</Alert>
          </Snackbar> */}
        </div>
      </AnimatedModal>
    </>
  );
};

export default AddTowerImageSet;
